import { html } from 'lit';
const AllDocs =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M10.167 3.25c-.783 0-1.417.634-1.417 1.417V15.5c0 .782.634 1.417 1.417 1.417h8.666c.783 0 1.417-.635 1.417-1.417V8.125h-2.5a1.833 1.833 0 0 1-1.833-1.833V3.25zm7.25 1.223 1.913 2.152h-1.58a.333.333 0 0 1-.333-.333zM7.25 4.667a2.917 2.917 0 0 1 2.917-2.917h6.5a.75.75 0 0 1 .56.252l4.334 4.875a.75.75 0 0 1 .189.498V15.5a2.917 2.917 0 0 1-2.917 2.917H16.75v.916a2.917 2.917 0 0 1-2.917 2.917H5.708a3.46 3.46 0 0 1-3.458-3.458V8.5a2.917 2.917 0 0 1 2.917-2.917H7.25zm0 2.416H5.167c-.783 0-1.417.635-1.417 1.417v10.292c0 1.081.877 1.958 1.958 1.958h8.125c.783 0 1.417-.634 1.417-1.417v-.916h-5.083A2.917 2.917 0 0 1 7.25 15.5zm4.333-.25a.75.75 0 0 1 .75-.75h1.409a.75.75 0 0 1 0 1.5h-1.409a.75.75 0 0 1-.75-.75m0 3.25a.75.75 0 0 1 .75-.75h4.334a.75.75 0 0 1 0 1.5h-4.334a.75.75 0 0 1-.75-.75m0 3.25a.75.75 0 0 1 .75-.75h3.25a.75.75 0 0 1 0 1.5h-3.25a.75.75 0 0 1-.75-.75" clip-rule="evenodd"/>
  </svg>
`;
export default AllDocs;
